<template>
  <div v-if="isAdmin" class="font-inter p-8">
    <h1 class="text-2xl font-bold mb-6">Talent Profile</h1>

    <div v-if="loading" class="text-center">
      <div class="animate-pulse">
        <!-- Skeleton loading effect -->
        <div class="h-6 bg-gray-300 rounded my-4"></div>
        <div class="h-6 bg-gray-300 rounded my-4"></div>
        <div class="h-6 bg-gray-300 rounded my-4"></div>
        <div class="h-6 bg-gray-300 rounded my-4"></div>
        <div class="h-6 bg-gray-300 rounded my-4"></div>
        <div class="h-6 bg-gray-300 rounded my-4"></div>
        <div class="h-6 bg-gray-300 rounded my-4"></div>
        <div class="h-6 bg-gray-300 rounded my-4"></div>
      </div>
    </div>

    <div v-else-if="talent">
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700">First Name:</label>
        <p>{{ talent.user.first_name }}</p>
      </div>
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700">Last Name:</label>
        <p>{{ talent.user.last_name }}</p>
      </div>
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700">Email:</label>
        <p>{{ talent.user.email }}</p>
      </div>
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700">Phone:</label>
        <p>{{ talent.user.phone }}</p>
      </div>
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700">Portfolio URL:</label>
        <p>{{ talent.portfolio_url }}</p>
      </div>
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700">Skills:</label>
        <ul>
          <li v-for="skill in talent.skills" :key="skill.skill_id">{{ skill.skill_name }}</li>
        </ul>
      </div>
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700">Projects:</label>
        <ul>
          <li v-for="project in talent.projects" :key="project.project_id">{{ project.project_name }}</li>
        </ul>
      </div>
    </div>

    <div v-else class="text-center">
      <p class="text-red-500">Failed to load talent profile.</p>
    </div>
  </div>
  <div v-else-if="isTalent">

  </div>
</template>

<script>
import apiClient from '@/axios';

export default {
  name: 'TalentProfileComponent',
  props: {
    talentId: {
      type: [String, Number], // Accepting both String and Number for flexibility
      required: true
    }
  },
  data() {
    return {
      talent: null,
      loading: true
    }
  },
  computed: {
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
      isManager() {
        return this.$store.getters.isManager;
      },
      isTalent() {
        return this.$store.getters.isTalent;
      },
    },
  methods: {
    async fetchTalentProfile() {
      try {
        const response = await apiClient.get(`/web/talents/${this.talentId}`);
        this.talent = response.data.data;
      } catch (error) {
        console.error('Error fetching talent profile:', error);
        this.talent = null; // Explicitly set to null if there's an error
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.fetchTalentProfile();
  }
}
</script>

<style scoped>
/* Add your styles here */
</style>
